import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Hook to scroll to top whenever the route changes
 */
const useScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])
}

export default useScrollToTop